import { ICriteria } from "src/app/core/services/criteria.interface";
import { HttpParams } from "@angular/common/http";

export class LiftBoardParameterCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'LiftParameter.Code asc';
  searchTerm: string = null;
  liftBoardId: number = null;
  parentId: number = null;
  all: boolean = false;

  paramsExport(): HttpParams {
    let params = new HttpParams()
      //.set('page', String(this.page))
      .set('orderby', this.orderby)
      //.set('pageSize', String(this.pageSize));

    if (this.liftBoardId && this.parentId == null && !this.all) {
      params = params.set('filter', 'LiftBoardId == ' + String(this.liftBoardId) + ' and ParentId == null');
    }

    if (this.liftBoardId && this.parentId != null && !this.all) {
      params = params.set('filter', 'LiftBoardId == ' + String(this.liftBoardId) + ' and ParentId == ' + String(this.parentId));
    }

    if (this.liftBoardId && this.all) {
      params = params.set('filter', 'LiftBoardId == ' + String(this.liftBoardId));
    }

    return params;
  }
}
